<template>
  <div class="card">
    <div class="row">
      <div class="col-sm-6">
        <v-text-field v-model="block.title" :label="domain ? 'Заголовок общего домена' : 'Заголовок общего блока:'" dense class="mb-7" @input="debouncedChanged" :error-messages="errors.save.title" />
        <v-select v-if="!domain" item-value="id" item-text="name" v-model="block.processor" :items="processors"
          label="Метод расчета" dense class="mb-4" @change="onChange"
        />
        <v-btn class="mr-3 _w-100" color="primary" @click="showIntervalsDialog=true"> Редактировать интервалы </v-btn>
      </div>
      <div class="col-sm-6">
        <v-textarea label="Описание" v-model="block.description" no-resize hide-details dense rows="6" class="mt-0 pt-0" @input="debouncedChanged"/>
        <div class="row mt-4" v-if="!domain">
          <div class="col-sm-6">
            <v-text-field
              v-model="block.max_score"
              label="Максимум:"
              dense class="_mb-7"
              @input="debouncedChanged"
              :error-messages="checkFloat(block.max_score)"
            />
          </div>
          <div class="col-sm-6">
            <v-text-field
              v-model="block.normalized_to"
              label="Нормировать по:"
              dense class="_mb-7"
              @input="debouncedChanged"
              :error-messages="checkFloat(block.normalized_to)"
            />
          </div>
        </div>
      </div>
    </div>
    <EditIntervalsDialog v-model="showIntervalsDialog" :block="block" modeOverallIntervals :domain="domain" />
  </div>
</template>

<script>
/* eslint-disable */
import { debounce } from 'lodash';
import { checkFloat, toFloat } from '@/common/util';
import { mapActions, mapGetters } from 'vuex';
import EditIntervalsDialog from '@/components/testEditor/EditIntervalsDialog.vue';

export default {
  components: {
    EditIntervalsDialog
  },
  props: {
    instrument: Object,
    domain:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showIntervalsDialog: false,
    };
  },
  computed: {
    ...mapGetters({
      loading: 'testEditor/loading',
      errors: 'testEditor/errors',
      processors: 'testEditor/processors',
    }),
    block() {
      return this.domain
        ? (this.instrument.overall_domain ?? {
          title: "Заголовок домена",
          description: "",
          instrument: this.instrument.id,
        })
        : (this.instrument.overall_block ?? {
          title: "Заголовок",
          description: "",
          max_score: 0,
          normalized_to: 0,
          instrument: this.instrument.id,
          processor: null
        });
    }
  },
  methods: {
    ...mapActions({
      saveBlockOverall: 'testEditor/saveBlockOverall',
      saveDomainOverall: 'testEditor/saveDomainOverall',
    }),
    onChange() {
      if (!this.domain){
        if (typeof checkFloat(this.block.max_score) === 'string' || typeof checkFloat(this.block.normalized_to) === 'string')
          return
        this.block.max_score = toFloat(this.block.max_score)
        this.block.normalized_to = toFloat(this.block.normalized_to)
      }

      if (this.domain){
        this.saveDomainOverall(this.block)
      }else {
        this.saveBlockOverall(this.block)
      }
    },
    debouncedChanged: debounce(function (val) {
      this.onChange();
    }, 500),
    errorField(field) {
      return
    },
    checkFloat,
  }

}
</script>

<style>
</style>
